import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import Loading from "../UI/Loading";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  title: {
    marginTop: "20px",
    marginBottom: "20px",
  },
});

const AlunoTurmaTableSelectView = ({
  alunosTurma,
  handleSelectAlunoTurma,
  isLoading,
}) => {
  const classes = useStyles();
  return (
    <div>
      <Typography className={classes.title} variant="body1">
        Selecione um aluno turma:
      </Typography>
      {isLoading ? (
        <Loading description="Carregando Alunos Turma..." />
      ) : (
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Número Chamada</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alunosTurma.map((at) => (
              <TableRow key={at.codigo}>
                <TableCell>{at.aluno.nome}</TableCell>
                <TableCell>{at.numeroChamada}</TableCell>
                <TableCell>
                  <Button
                    onClick={() => handleSelectAlunoTurma(at)}
                    variant="contained"
                    color="secondary"
                  >
                    Selecionar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default AlunoTurmaTableSelectView;
